import { getUserConfiguration } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

// Inbox plus is enabled in the UI when the user configuration InboxPlusTabs property is set. We
// need this to be set on the server so we guarantee the correct items are being sent in sessiondata
export function isInboxPlusEnabled(): boolean {
    return isInAnyInboxPlusTreatment() && getUserConfiguration().UserOptions.InboxPlusTabs !== null;
}

export function isInAnyInboxPlusExperiment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusDefaultTabs') ||
        isFeatureEnabled('tri-inboxPlusDefaultTabsControl') ||
        isFeatureEnabled('tri-inboxPlusEasyOn') ||
        isFeatureEnabled('tri-inboxPlusEasyOnControl')
    );
}

// The user will see Inbox Plus UI if any of these flags are enabled
export function isInAnyInboxPlusTreatment(): boolean {
    return isFeatureEnabled('tri-inboxPlusDefaultTabs') || isFeatureEnabled('tri-inboxPlusEasyOn');
}

export function isInEasyOnExperiment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusEasyOn') || isFeatureEnabled('tri-inboxPlusEasyOnControl')
    );
}
